module.exports = __webpack_public_path__ + "static/media/placeholder.96e3b78e.svg";